export default {
  'RequestCancelButtonSection.cancelRequest': {
    en: 'Cancel Request',
    fr: "Demande d'annulation",
  },
};
